/**
 * Production-only utility to prevent basic inspect/debugging of the application.
 * Disables context menu and common developer tool keyboard shortcuts.
 */

let isInitialized = false;

export const initInspectProtection = () => {
  // Active only in production to allow local debugging
  if (process.env.NODE_ENV !== 'production' || isInitialized) return;
  isInitialized = true;

  // 1. Disable Right Click (Context Menu)
  const handleContextMenu = (e) => {
    e.preventDefault();
  };
  document.addEventListener('contextmenu', handleContextMenu);

  // 2. Disable Keyboard Shortcuts
  const handleKeyDown = (e) => {
    // F12
    if (e.key === 'F12' || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }

    // Ctrl + Shift + I (Inspector) or Cmd + Option + I
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'I' || e.key === 'i' || e.keyCode === 73)) {
      e.preventDefault();
      return false;
    }

    // Ctrl + Shift + J (Console) or Cmd + Option + J
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'J' || e.key === 'j' || e.keyCode === 74)) {
      e.preventDefault();
      return false;
    }

    // Ctrl + Shift + C (Element Selector)
    if ((e.ctrlKey || e.metaKey) && e.shiftKey && (e.key === 'C' || e.key === 'c' || e.keyCode === 67)) {
      e.preventDefault();
      return false;
    }

    // Ctrl + U (View Source) or Cmd + Option + U
    if ((e.ctrlKey || e.metaKey) && (e.key === 'U' || e.key === 'u' || e.keyCode === 85)) {
      e.preventDefault();
      return false;
    }
  };
  document.addEventListener('keydown', handleKeyDown);

  // 3. DevTools Detection & Interaction Blocking
  // Detects if devtools is open via window size difference and overlays a blocker
  let devtoolsBlocker = null;

  const checkDevTools = () => {
    const threshold = 160;
    // Check if the difference between outer and inner window dimensions is significant
    const widthThreshold = window.outerWidth - window.innerWidth > threshold;
    const heightThreshold = window.outerHeight - window.innerHeight > threshold;
    
    // Also check for zoomed pages which might trigger false positives
    const isZoomed = Math.round(window.devicePixelRatio * 100) !== 100;

    if (!isZoomed && (widthThreshold || heightThreshold)) {
      if (!devtoolsBlocker) {
        devtoolsBlocker = document.createElement('div');
        devtoolsBlocker.id = 'devtools-blocker';
        devtoolsBlocker.style.position = 'fixed';
        devtoolsBlocker.style.top = '0';
        devtoolsBlocker.style.left = '0';
        devtoolsBlocker.style.width = '100vw';
        devtoolsBlocker.style.height = '100vh';
        devtoolsBlocker.style.backgroundColor = '#fff';
        devtoolsBlocker.style.zIndex = '999999999';
        devtoolsBlocker.style.display = 'flex';
        devtoolsBlocker.style.alignItems = 'center';
        devtoolsBlocker.style.justifyContent = 'center';
        devtoolsBlocker.style.fontFamily = 'sans-serif';
        devtoolsBlocker.style.color = '#333';
        devtoolsBlocker.innerHTML = '<h2>Developer tools detected. Please close to continue using the application.</h2>';
        document.body.appendChild(devtoolsBlocker);
      }
    } else {
      if (devtoolsBlocker && devtoolsBlocker.parentNode) {
        devtoolsBlocker.parentNode.removeChild(devtoolsBlocker);
        devtoolsBlocker = null;
      }
    }
  };

  // Run the check on resize
  window.addEventListener('resize', checkDevTools);
  
  // Return cleanup function to prevent memory leaks (though usually this lives for the lifetime of the app)
  return () => {
    document.removeEventListener('contextmenu', handleContextMenu);
    document.removeEventListener('keydown', handleKeyDown);
    window.removeEventListener('resize', checkDevTools);
    if (devtoolsBlocker && devtoolsBlocker.parentNode) {
      devtoolsBlocker.parentNode.removeChild(devtoolsBlocker);
    }
    isInitialized = false;
  };
};
